import React from 'react';

// Components
class NotFound extends React.Component {
  componentWillMount() {
    const ua = document.querySelector('html').getAttribute('data-ua');
    let examTitle = ua.split('Exam Title:')[1];

    if(!examTitle) {
      examTitle = 'your exam';
    } else {
      examTitle = `“${examTitle}”`;
    }

    this.state = {
      examTitle
    };
  }

  render() {
    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <h1 className="panel__title">Start VTC Session</h1>
          <p>To start your session, please navigate to <strong>{this.state.examTitle}</strong> in your online course.</p>
        </div>
      </main>
    )
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/app/components/VTCNotice.js